<template>
  <div>
    <c-search-box @enter="getLawList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 국가 -->
          <c-select
            type="search"
            codeGroupCd="REGUL_ITEM_NATION_CD"
            itemText="codeName"
            itemValue="code"
            name="regulItemNationCd"
            label="국가"
            v-model="searchParam.regulItemNationCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="REGULATION_BILL_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="regulationBillCd"
            label="규제법규"
            v-model="searchParam.regulationBillCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <!-- 사용여부 -->
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <c-table
          ref="table"
          title="규제항목 목록"
          tableId="table"
          :columnSetting="false"
          :isFullScreen="false"
          :columns="grid.columns"
          :data="grid.data"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn label="검색" icon="search" @btnClicked="getLawList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <q-form ref="editForm">
          <c-card title="상세" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn v-if="editable" label="신규" icon="add" @btnClicked="addLaw" />
                <c-btn
                  v-if="editable && saveable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="saveType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveLaw"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-select
                  :required="true"
                  codeGroupCd="REGULATION_BILL_CD"
                  type="edit"
                  itemText="codeName"
                  itemValue="code"
                  name="regulationBillCd"
                  label="규제법규"
                  v-model="data.regulationBillCd"
                  :editable="editable && dataeditable"
                ></c-select>
              </div>
              <div class="col-6">
                <c-text
                  :editable="false"
                  label="규제항목코드"
                  name="regulatedItemCd"
                  v-model="data.regulatedItemCd">
                </c-text>
              </div>
              <div class="col-12">
                <c-text
                  :editable="editable && dataeditable"
                  :required="true"
                  label="규제항목 명"
                  name="regulatedItemName"
                  v-model="data.regulatedItemName">
                </c-text>
              </div>
              <div class="col-12">
                <c-textarea
                  :counter="true"
                  :maxlength="500"
                  :editable="editable && dataeditable"
                  :rows="5"
                  label="규제 설명"
                  name="regulationDesc"
                  v-model="data.regulationDesc">
                </c-textarea>
              </div>
              <div class="col-6">
                <c-select
                  :editable="editable && dataeditable"
                  type="edit"
                  codeGroupCd="REGUL_ITEM_NATION_CD"
                  itemText="codeName"
                  itemValue="code"
                  label="국가"
                  name="regulItemNationCd"
                  v-model="data.regulItemNationCd"
                ></c-select>
              </div>
              <div class="col-6">
                <c-checkbox
                  :editable="editable && dataeditable"
                  :isFlag="true"
                  label="사용여부"
                  name="useFlag"
                  v-model="data.useFlag"
                />
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'law-manage',
  data() {
    return {
      listUrl: '',
      detailUrl: '',
      insertUrl: '',
      updateUrl: '',
      saveable: false,
      editable: true,
      dataeditable: false,
      updateMode: false,
      isSave: false,
      saveUrl: transactionConfig.sys.attach.insert.url,
      saveType: 'POST',
      searchUrl: '',
      searchParam: {
        useFlag: null,
        nationFlag: null,
        regulationBillCd: null,
        regulItemNationCd: null,
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      data: {
        regulatedItemCd: '',  // 규제항목 코드
        regulationBillCd: null,  // 규제법규 코드
        regulatedItemName: '',  // 규제항목 명
        regulationDesc: '',  // 규제 설명
        regulItemNationCd: null,
        useFlag: 'Y',  // 사용여부
        nationFlag: 'Y',  // 국내외구분(Y:국내,N:국외)
      },
      grid: {
        columns: [
          {
            name: 'regulItemNationName',
            field: 'regulItemNationName',
            label: '국가',
            align: 'center',
            sortable: true,
            style: 'width: 70px',
          },
          {
            name: 'regulationBillName',
            field: 'regulationBillName',
            label: '규제법규',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regulatedItemCd',
            field: 'regulatedItemCd',
            label: '규제항목 코드',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제항목 명',
            align: 'left',
            sortable: true,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            align: 'center',
            sortable: true,
            style: 'width: 70px',
          },
        ],
        data: [],
      },
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.dataeditable = false;
      // api scope
      this.listUrl = selectConfig.mdm.mam.regulation.item.list.url;
      this.detailUrl = selectConfig.mdm.mam.regulation.item.get.url;
      this.insertUrl = transactionConfig.mdm.mam.regulation.insert.url;
      this.updateUrl = transactionConfig.mdm.mam.regulation.update.url;
      this.getLawList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getLawList() {
      this.getList();
      this.rowRemoveSelect();
      this.reset();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
      this.saveable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.updateMode = true;
      this.$http.url = this.$format(this.detailUrl, row.regulatedItemCd);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
        this.dataeditable = true;
      },
      () => {
      });
    },
    addLaw() {
      this.saveable = true;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        regulatedItemCd: '',  // 규제항목 코드
        regulationBillCd: null,  // 규제법규 코드
        regulatedItemName: '',  // 규제항목 명
        regulationDesc: '',  // 규제 설명
        useFlag: 'Y',  // 사용여부
        nationFlag: 'Y',  // 국내외구분(Y:국내,N:국외)
      };
      this.rowRemoveSelect();
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        regulatedItemCd: '',  // 규제항목 코드
        regulationBillCd: null,  // 규제법규 코드
        regulatedItemName: '',  // 규제항목 명
        regulationDesc: '',  // 규제 설명
        useFlag: 'Y',  // 사용여부
        nationFlag: 'Y',  // 국내외구분(Y:국내,N:국외)
      };
    },
    saveLaw() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.saveType == 'PUT') {
        this.getList();
        this.rowClick({ regulatedItemCd: result.data.regulatedItemCd })
      } else {
        this.getLawList();
      }
    },
  }
};
</script>
